import { render, staticRenderFns } from "./kpi-target-detail.vue?vue&type=template&id=ad2f84b2&"
import script from "./kpi-target-detail.vue?vue&type=script&lang=js&"
export * from "./kpi-target-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports